import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { useLabelContext } from "@/components/Price/label/context/label.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Entry = ({ className, children }: Props) => {
    const { position, type } = useLabelContext();

    return (
        <span
            className={cn(
                "tw:block tw:bg-danger tw:text-white tw:px-1.5 tw:py-0.5",
                {
                    "tw:group-[*]/label:last:rounded-r-sm": position === "left",
                    "tw:group-[*]/label:first:rounded-l-sm":
                        position === "left" && type === "label",
                    "tw:group-[*]/label:last:rounded-l-sm":
                        position === "right",
                    "tw:group-[*]/label:first:rounded-r-sm":
                        position === "right" && type === "label"
                },
                className
            )}
        >
            {children}
        </span>
    );
};
